function lang(state = [], action = {}) {
    return state;
}

export default lang;